"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_config_1 = __importDefault(require("react-native-config"));
class Client {
    static httpGet(url, token, getErrorMessage = false) {
        return new Promise(async (resolve, reject) => {
            fetch(`${react_native_config_1.default.API_URL}${url}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token.token}`,
                    ...(token.client && { 'Nextep-Client': token.client }),
                    ...(token.prospect && { 'Nextep-Prospect': token.prospect }),
                }
            }).then(response => {
                if (response.status == 200) {
                    resolve(response.json());
                }
                else {
                    if (getErrorMessage) {
                        response.text().then((text) => {
                            reject({
                                status: response.status,
                                body: text
                            });
                        });
                    }
                    else {
                        reject(response.status);
                    }
                }
            }).catch(error => {
                reject(error);
            });
        });
    }
    static httpGetRawResponse(url, token) {
        return new Promise(async (resolve, reject) => {
            fetch(`${react_native_config_1.default.API_URL}${url}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token.token}`,
                    ...(token.client && { 'Nextep-Client': token.client }),
                    ...(token.prospect && { 'Nextep-Prospect': token.prospect }),
                }
            }).then(response => {
                if (response.status == 200) {
                    resolve(response.text());
                }
                else {
                    reject(response.status);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }
    static httpGetUnauthenticated(url, getErrorMessage = false) {
        return new Promise(async (resolve, reject) => {
            fetch(`${react_native_config_1.default.API_URL}${url}`, {
                method: 'GET',
            }).then(response => {
                if (response.status == 200) {
                    resolve(response.json());
                }
                else {
                    if (getErrorMessage) {
                        response.text().then((text) => {
                            reject({
                                status: response.status,
                                body: text
                            });
                        });
                    }
                    else {
                        reject(response.status);
                    }
                }
            }).catch(error => {
                reject(error);
            });
        });
    }
    static httpPost(url, token, body) {
        return new Promise(async (resolve, reject) => {
            fetch(`${react_native_config_1.default.API_URL}${url}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token.token}`,
                    ...(token.client && { 'Nextep-Client': token.client }),
                    ...(token.prospect && { 'Nextep-Prospect': token.prospect }),
                },
                body: JSON.stringify(body)
            }).then(response => {
                if (response.status == 200) {
                    resolve(response.json().catch(() => null));
                }
                else if (response.status == 400) {
                    response.text().then((text) => {
                        reject({
                            status: response.status,
                            body: text
                        });
                    });
                }
                else {
                    reject({
                        status: response.status
                    });
                }
            }).catch(error => {
                reject(error);
            });
        });
    }
    static httpDelete(url, token, body) {
        return new Promise(async (resolve, reject) => {
            fetch(`${react_native_config_1.default.API_URL}${url}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token.token}`,
                    ...(token.client && { 'Nextep-Client': token.client }),
                    ...(token.prospect && { 'Nextep-Prospect': token.prospect }),
                },
                body: JSON.stringify(body)
            }).then(response => {
                if (response.status == 200) {
                    resolve(response.json().catch(() => null));
                }
                else if (response.status == 400) {
                    response.text().then((text) => {
                        reject({
                            status: response.status,
                            body: text
                        });
                    });
                }
                else {
                    reject({
                        status: response.status
                    });
                }
            }).catch(error => {
                reject(error);
            });
        });
    }
    static httpGCFPost(url, body, headers = {}) {
        return new Promise(async (resolve, reject) => {
            fetch(`${react_native_config_1.default.GCF_URL}${url}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(headers ?? {})
                },
                body: JSON.stringify(body)
            }).then(response => {
                if (response.status == 200) {
                    resolve(response.json().catch(() => null));
                }
                else {
                    response.text().then((text) => {
                        reject({
                            status: response.status,
                            body: text
                        });
                    });
                }
            }).catch(error => {
                reject(error);
            });
        });
    }
    static httpPut(url, token, body) {
        return new Promise(async (resolve, reject) => {
            fetch(`${react_native_config_1.default.API_URL}${url}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token.token}`,
                    ...(token.client && { 'Nextep-Client': token.client }),
                    ...(token.prospect && { 'Nextep-Prospect': token.prospect }),
                },
                body: body === undefined ? undefined : JSON.stringify(body),
            })
                .then(async (response) => {
                if (response.status === 200) {
                    resolve((await response.json().catch(() => null)));
                }
                else if (response.status === 204) {
                    resolve(null);
                }
                else if (response.status === 400) {
                    const text = await response.text();
                    reject({ status: response.status, body: text });
                }
                else {
                    reject({ status: response.status });
                }
            }).catch(error => {
                reject(error);
            });
        });
    }
    static httpGetText(url, token) {
        return new Promise(async (resolve, reject) => {
            try {
                const fullUrl = `${react_native_config_1.default.API_URL}${url}`;
                const response = await fetch(fullUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token.token}`,
                        ...(token.client && { 'Nextep-Client': token.client }),
                        ...(token.prospect && { 'Nextep-Prospect': token.prospect }),
                        'Accept': 'text/csv, text/plain, */*',
                    }
                });
                const text = await response.text();
                if (response.status === 200) {
                    resolve(text);
                }
                else {
                    reject({ status: response.status, body: text });
                }
            }
            catch (err) {
                reject({ status: -1, body: String(err) });
            }
        });
    }
    static buildUrl(url) {
        return `${react_native_config_1.default.API_URL}${url}`;
    }
    static buildHeaders(token, extra = {}) {
        return {
            'Authorization': `Bearer ${token.token}`,
            ...(token.client && { 'Nextep-Client': token.client }),
            ...(token.prospect && { 'Nextep-Prospect': token.prospect }),
            ...extra,
        };
    }
}
exports.default = Client;
